<template>
    <Header12 />
    <div class="body">
        <section class="background-clair">
            <div class="d-flex align-items-center justify-content-between">
                <div class="w-50 title-menu">
                    <span class="span-background" id="Leadership et Management">
                        Leadership et <br />Management
                    </span>
                </div>
                <div class="w-50 desktop">
                    <img src="/images/pages/organisme-formation.jpg" alt="Organisme de formation">
                </div>
            </div>
        </section>
        <section class="mb-3">
            <NavLeft tab="leadership-management" breadcrumb1="" breadcrumb2="" />
        </section>
        <section class="background-blue">
            <Programs />
        </section>
        <section class="background-orange">
            <PoleDeFormation />
        </section>
        <section class="background-rose">
            <AvisClient :idCategory="78" />
        </section>
        <section>
            <NousContacter />
        </section>
        <section>
            <Footer :dark_bg="true" />
        </section>
    </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue'
import NousContacter from '@/components/emci/NousContacter/index.vue'
import Footer from '@/components/emci/Footer/index.vue'
import NavLeft from "@/components/emci/NavLeft/index.vue"
import AvisClient from '@/components/emci/AvisClient/index.vue';
import PoleDeFormation from '@/components/emci/PoleDeFormation/index.vue'
import Programs from './Programs/index.vue'
useHead({
    title: "EMCI - programme de formation Leadership et Management",
    meta: [
        {
            name: "description",
            content: "Les formations EMCI en matière de leadership et management  : prise de décision, la communication, la planification stratégique et la gestion du temps"
        }
    ]
})
</script>

<style scoped>
.body {
    overflow: hidden !important;
    margin-top: 120px;
}

.background-orange {
    background: #FFD186;
}


img {
    width: 68.6875rem;
    height: 20.1875rem;
    border-radius: 10.09375rem 0rem 0rem 10.09375rem;
    object-fit: cover;
}

.title-menu {
    font-family: Nunito;
    font-size: 3.4375rem;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    letter-spacing: -0.05156rem;
    text-transform: uppercase;
    color: #25233E;
    padding-left: 10rem;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
    .body {
        margin-top: 85px;
    }

    .span-background {
        left: -140px;
        font-size: 30px;
        line-height: normal;
        margin-bottom: 35px;
    }
}
</style>